"use client";

import { c as _c } from "react/compiler-runtime";
import { parseAsArrayOf, parseAsString, useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
export function useCurrencyQueryParam() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsArrayOf(parseAsString).withDefault([]);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [values, setValues] = useQueryState(QUERY_PARAM_KEYS.currency, t0);
  let t1;
  if ($[1] !== setValues || $[2] !== values) {
    t1 = async function onSelectCurrency(currency) {
      const newValues = values.includes(currency) ? values.filter(c => c !== currency) : [...values, currency];
      await setValues(newValues.length > 0 ? newValues : null);
    };
    $[1] = setValues;
    $[2] = values;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onSelectCurrency = t1;
  let t2;
  if ($[4] !== onSelectCurrency || $[5] !== values) {
    t2 = {
      currency: values,
      onSelectCurrency
    };
    $[4] = onSelectCurrency;
    $[5] = values;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}